import PropTypes from 'prop-types'
import React from 'react'
import PersonalRu from 'modules/Forms/Finance/PaymentProfileCreate/subcomponents/Personal/Ru'
import PersonalForeign from 'modules/Forms/Finance/PaymentProfileCreate/subcomponents/Personal/Foreign'
import { IS_APP_PRODUCT_GETUNIQ } from 'utils/constants/product'

const PersonalFormFields = (props) => {
  return IS_APP_PRODUCT_GETUNIQ ? <PersonalRu {...props} /> : <PersonalForeign {...props} />
}

PersonalFormFields.propTypes = {
  details: PropTypes.object,
}

export default PersonalFormFields
